/**
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
export const GTM_ID = "google.tag.manager.container.id";
export const GTM_AUTH = "google.tag.manager.auth";
export const GTM_PREVIEW = "google.tag.manager.preview";
export const GA_VERSIONS = "google.analytics.versions";
export const GA_VERSION_UA = "UA";
export const GA_VERSION_GA4 = "GA4";
export const PAGE_LOAD = "pageLoad";
export const KEYWORD_SEARCH = "keywordSearch";
export const NAVIGATION_CLICK = "navigationClick";
export const FORM_COMPLETION = "formCompletion";
export const PRODUCT_IMPRESSION = "productImpression";
export const PRODUCT_CLICK = "productClick";
export const PRODUCT_DETAIL = "productDetail";
export const ADD_TO_CART = "addToCart";
export const REMOVE_FROM_CART = "removeFromCart";
export const PROMO_VIEW = "promoView";
export const PROMOTION_CLICK = "promotionClick";
export const PURCHASE = "purchase";
export const CHECK_OUT = "checkout";
export const CHECK_OUT_OPTION = "checkoutOption";
export const HOME = "Home";
export const ONSITE_SEARCH = "Onsite Search";
export const LISTER = "Lister";
export const PDP = "PDP";
export const CHECKOUT = "Checkout";
export const CONTENT = "Content";
export const CART = "Cart";

// List of eSpots/promotions for which Google tagging is not required.
export const DISABLED_ESPOT_LIST = ["HeaderStoreLogo", "FooterStoreLogo"];
export const GA4_EVENT_ADD_TO_CART = "GA4_add_to_cart";
export const GA4_EVENT_REMOVE_FROM_CART = "GA4_remove_from_cart";
export const GA4_EVENT_BEGIN_CHECKOUT = "GA4_begin_checkout";
export const GA4_EVENT_ADD_PAYMENT_INFO = "GA4_add_payment_info";
export const GA4_EVENT_ADD_SHIPPING_INFO = "GA4_add_shipping_info";
export const GA4_EVENT_PURCHASE = "GA4_purchase";
export const GA4_EVENT_VIEW_CART = "GA4_view_cart";
export const GA4_EVENT_VIEW_PROMOTION = "GA4_view_promotion";
export const GA4_EVENT_SELECT_PROMOTION = "GA4_select_promotion";
export const GA4_EVENT_VIEW_ITEM_LIST = "GA4_view_item_list";
export const GA4_EVENT_SELECT_ITEM = "GA4_select_item";
export const GA_EVENT_VIEW_ITEM = "GA4_view_item";
